export enum AppPath {
  Consignments = 'consignments',
  Estimates = 'estimates',
  SaleNotes = 'sale-notes',
  Settlements = 'settlements',
  Reservations = 'reservations',
  Vehicles = 'vehicles',
  Publish = 'publish',
  Clients = 'clients',
  Deals = 'deals',
  Reports = 'reports',
  Loans = 'loans', // These are called "credits" on the db, which is wrong
  Templates = 'templates',
  Purchases = 'purchases',
  Messages = 'messages',
  Users = 'users',
  Branches = 'branches',
  Dealership = 'dealership',
  Sales = 'sales',
  Transfers = 'transfers',
  Patente = 'patente',
}
